<app-table
    [items]="store.items()"
    [columns]="columns"
    [tableTitle]="(prefix + 'title') | translate"
    [translatePrefix]="prefix"
    [hideCheckboxes]="true"
    (createCallback)="openDialog()"
    (detailCallback)="openDialog($event)"
></app-table>
